import React, { Component } from 'react';
import { connect } from 'react-redux';

import Swal from 'sweetalert2';

import classes from './Panel.module.scss';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';

import Button from 'Flow2/components/UI/Button/Button';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';

import * as actions from 'store/actions/index';
/*import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';*/

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FormattedMessage, injectIntl } from 'react-intl';

import Spinner from 'Flow2/components/UI/Spinner/Spinner';


export const PANEL_VIEW_STATE_OPEN = "PANEL_VIEW_STATE_OPEN";
export const PANEL_VIEW_STATE_CLOSED = "PANEL_VIEW_STATE_CLOSED";

class Panel extends Component {

    constructor(props) {
        super(props);
        this.state = { }
    }

/*
    componentDidMount = () => {
        this.props.loadUsers();
    }
*/
    togglePanel = () => {
        if (this.props.viewState === PANEL_VIEW_STATE_OPEN) {
            this.props.close();
        } else {
            this.props.open();
        }
    }
    
	getContent = () => {
		return "";
	}
	
	getHeader = () => {
		return <div style={{ flex: 1 }}><FormattedMessage id={this.props.title || "panel.title.default" } defaultMessage="Panel"/></div>;
	}
	
	getControls = () => {
		return "";
	}
	
	// ????????????????????????????????
	
	getPanelSwitch = () => {
		if(!this.props.panels) {
			return "";
		}
		
		
		return "";
	}
	
	// ????????????????????????????????

    render = () => {
        let content = "";
		let header = "";

        if (this.props.viewState === PANEL_VIEW_STATE_OPEN) {
            content = this.getContent();
			header = this.getHeader();
        }

        const attachedClasses = [classes.Metadata, classes[this.props.viewState], classes[this.state.mode], "relative"];

        return (
            <FlexColumn className={attachedClasses.join(' ')}>
                { /*this.showMandatoryMessage()*/ }
                <Overlay props={this.props} />
                <Toggle viewState={this.props.viewState} toggle={this.togglePanel} />
				<FlexColumn className={[classes.Container, "Metadata", this.props.type].join(' ')}>
                    <FlexRow className={classes.Header}>
					
                        { header }
						
                    </FlexRow>
                    <FlexColumn className={classes.Content}>
					
                        { content }
						
                    </FlexColumn>
                </FlexColumn>
            </FlexColumn>
        );
    }
	
	/*
	static getDerivedStateFromProps(nextProps, prevState) {
        return null;
    }
	*/
}

const Overlay = (props) => {
	if(!props.loading) {
		return "";
	}
	
	return (
		<div className={classes.Overlay}>
			<Spinner />
		</div>
	);
}

const Toggle = (props) => {
    let cls = [ classes.ToggleClosed ];
	let label = (<><FontAwesomeIcon icon="chevron-left" /></>);

    if (props.viewState === PANEL_VIEW_STATE_OPEN) {
		cls = [ classes.ToggleOpen ];
		label = (<><FontAwesomeIcon icon="chevron-right" /> <FormattedMessage id="sidebar.minimize" /> <FormattedMessage id="sidebar.metadata" /></>);
    }

    return (
        <FlexRow className={cls.join(' ')}>
            <Button
                btnType="Transparent"
                clicked={props.toggle}>
					{ label }
            </Button>
        </FlexRow>
    );
}
/*
const mapStateToProps = (state) => {
    return {
        viewState: state.ui.metadataState,
        open: state.ui.metadataState === 'open',
        loading: state.metadata.loading
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        opened: () => dispatch(actions.metadataOpened()),
        closed: () => dispatch(actions.metadataClosed())
    }
}
*/
export default (Panel);
